module.exports = __webpack_public_path__ + "img/spring-replacement.18ddb19b.webp";